module.exports = __webpack_public_path__ + "static/img/chuzhongyingyu2.894d13c6.jpg";